//Imports node_modules
import React, { useState } from "react";


//Variaveis inicias
const initialState = {

    uniqueDeviceID: '',
    isInsertingGlobal: false,

    groupPe: {
        pe: 0,
        iniciais: '',
        nmpe: '',
        pin: '',
        eEquipa: false,
        dispUniqueId: ''
    },

    pe: {
        npe: 0,
        iniciais: "",
        nmpe: "",
        pin: "",
        eEquipa: false,
        dispUniqueId: ""
    },

    zone: {
        nctt: 0,
        nmctt: "",
        productionCount: "",
    },

    obra: {
        cct: "",
        custamp: "",
        descricao: "",
    },

    //Variaveis para a pag. groupProductionPage
    stepsList: [],
    hasGroupProdcutionStarted: false,
    operationGroupProduction: [],
    selectedObraForGroupProduction: [],

    isEdetingGlobalUpdate: 0,
}

export const globalVariables = React.createContext(initialState)

const GlobalVariables = params => {
    const [state, setState] = useState(initialState)

    function updateState(key, value) {
        setState({
            ...state,
            [key]: value
        })
    }

    function resetPe() {
        setState({
            ...state,
            isInsertingGlobal: false,
            pe: {
                npe: 0,
                iniciais: "",
                nmpe: "",
                eEquipa: false,
                dispUniqueId: ""
            },
            groupPe: {
                pe: 0,
                iniciais: '',
                nmpe: '',
                eEquipa: false,
                dispUniqueId: ''
            },
        })
    }

    function resetGroupPe() {
        setState({
            ...state,
            groupPe: {
                pe: 0,
                iniciais: '',
                nmpe: '',
                eEquipa: false,
                dispUniqueId: ''
            },
        })
    }

    function resetAll() {
        setState({
            ...state,
            isInsertingGlobal: false,
            groupPe: {
                pe: 0,
                iniciais: '',
                nmpe: '',
                eEquipa: false,
                dispUniqueId: ''
            },

            pe: {
                npe: 0,
                iniciais: "",
                nmpe: "",
                eEquipa: false,
                dispUniqueId: ""
            },

            zone: {
                nctt: 0,
                nmctt: "",
                productionCount: "",
            },

            obra: {
                cct: "",
                custamp: "",
                descricao: "",
            }
        })
    }

    function setZoneAndPe(pe, zone) {
        setState({
            ...state,
            pe: pe,
            zone: zone,
        })
    }

    function setCloseProductionRedirectionVars(user, zone, obra) {
        setState({
            ...state,
            pe: user,
            zone: zone,
            obra: obra,
        })
    }

    function setGroupPe(key, value) {
        setState({
            ...state,
            [key]: value,
            isInsertingGlobal: true,
        })
    }

    function setZone(key, value) {
        setState({
            ...state,
            [key]: value,
            isInsertingGlobal: true,
        })
    }


    function defineGroupProduction(stepList, operacoes) {
        setState({
            ...state,
            hasGroupProdcutionStarted: true,
            stepsList: stepList,
            operationGroupProduction: operacoes,

        })
    }


    function stopGroupProduction(operacoes) {
        setState({
            ...state,
            hasGroupProdcutionStarted: false,
            stepsList: [],
            operationGroupProduction: operacoes,
        })
    }


    function addProjectToGroupProdcution(steps, operacoes) {
        setState({
            ...state,
            hasGroupProdcutionStarted: true,
            stepsList: steps,
            operationGroupProduction: operacoes,
        })
    }

    return (
        <globalVariables.Provider value={{
            //Variavels
            apiBaseUrl: params.serverData.SERVER_URL,
            uniqueDeviceID: state.uniqueDeviceID,
            pe: state.pe,
            groupPe: state.groupPe,

            zone: state.zone,
            obra: state.obra,
            isInsertingGlobal: state.isInsertingGlobal,
            stepsList: state.stepsList,
            hasGroupProdcutionStarted: state.hasGroupProdcutionStarted,
            operationGroupProduction: state.operationGroupProduction,
            selectedObraForGroupProduction: state.selectedObraForGroupProduction,
            isEdetingGlobalUpdate: state.isEdetingGlobalUpdate,

            //---Funções
            //t = text, n = number, a = object/array b= boolean, d= date

            //Update States
            setIsEdetingGlobalUpdate: a=> updateState('isEdetingGlobalUpdate', a),
            setSelectedObraForGroupProduction: a=> updateState('selectedObraForGroupProduction', a),
            setOperationGroupProduction: a=> updateState('operationGroupProduction' , a),
            setHasGroupProdcutionStarted: b=> updateState('hasGroupProdcutionStarted' , b),
            setStepList: a => updateState('stepsList', a),
            setIsInsertingGlobal: b => updateState('isInsertingGlobal', b),
            setPe: a => updateState('pe', a),

            setGroupPe: a => setGroupPe('groupPe', a),

            defineGroupProduction: (stepList, operacoes) => defineGroupProduction(stepList, operacoes),
            stopGroupProduction: (operacoes) => stopGroupProduction(operacoes),
            addProjectToGroupProdcution: (steps, operacoes) => addProjectToGroupProdcution(steps, operacoes),

            setZone: a => setZone('zone', a),
            setObra: a => updateState('obra', a),
            setUniqueDeviceID: t => updateState('uniqueDeviceID', t),
            setZoneAndPe: (pe, zone) => setZoneAndPe(pe, zone),
            setCloseProductionRedirectionVars: (user, zone, obra) => setCloseProductionRedirectionVars(user, zone, obra),

            //Set variables

            //Reset Values
            ResetPe: _ => resetPe(),
            ResetGroupPe: _ => resetGroupPe(),
            ResetAll: _ => resetAll(),

            //---Fim Funções
        }}>
            {params.children}
        </globalVariables.Provider>
    )
}

export default GlobalVariables